import { tokenMainKeys } from "../../../utils/constants";
import { mainRedirectToIntranetPortal } from "../../common-utilities/utils/common-utils";

export const redirectToIntranetPortal = () => {
  return mainRedirectToIntranetPortal(tokenMainKeys.subs);
};
